import { defineMessage } from "react-intl";

export const rateMessages = {
  mlHours: defineMessage({
    id: "inpatient.prescribe.rate.ml_hours",
    defaultMessage: "ml/hour",
  }),
};

export const minimumDoseIntervalMessages = {
  hours: defineMessage({
    id: "inpatient.prescribe.minimumDoseIntervalUnit.hours",
    defaultMessage: "{value, plural, one {Hour} other {Hours}}",
  }),
};

export const routeMessages = {
  buccal: defineMessage({
    id: "inpatient.prescribe.route.buccal",
    defaultMessage: "Buccal",
  }),
  ear: defineMessage({
    id: "inpatient.prescribe.route.ear",
    defaultMessage: "Ear",
  }),
  eye: defineMessage({
    id: "inpatient.prescribe.route.eye",
    defaultMessage: "Eye",
  }),
  inhalation: defineMessage({
    id: "inpatient.prescribe.route.inhalation",
    defaultMessage: "Inhalation",
  }),
  intramuscular: defineMessage({
    id: "inpatient.prescribe.route.intramuscular",
    defaultMessage: "Intramuscular",
  }),
  intravenous: defineMessage({
    id: "inpatient.prescribe.route.intravenous",
    defaultMessage: "Intravenous",
  }),
  nasal: defineMessage({
    id: "inpatient.prescribe.route.nasal",
    defaultMessage: "Nasal",
  }),
  nasogastric: defineMessage({
    id: "inpatient.prescribe.route.nasogastric",
    defaultMessage: "Nasogastric",
  }),
  oral: defineMessage({
    id: "inpatient.prescribe.route.oral",
    defaultMessage: "Oral",
  }),
  rectal: defineMessage({
    id: "inpatient.prescribe.route.rectal",
    defaultMessage: "Rectal",
  }),
  subcutaneous: defineMessage({
    id: "inpatient.prescribe.route.subcutaneous",
    defaultMessage: "Subcutaneous",
  }),
  sublingual: defineMessage({
    id: "inpatient.prescribe.route.sublingual",
    defaultMessage: "Sublingual",
  }),
  topical: defineMessage({
    id: "inpatient.prescribe.route.topical",
    defaultMessage: "Topical",
  }),
  vaginal: defineMessage({
    id: "inpatient.prescribe.route.vaginal",
    defaultMessage: "Vaginal",
  }),
};

export const doseMessages = {
  mg: defineMessage({
    id: "inpatient.prescribe.unit.mg",
    defaultMessage: "mg",
  }),
  micrograms: defineMessage({
    id: "inpatient.prescribe.unit.micrograms",
    defaultMessage: "{value, plural, one {microgram} other {micrograms}}",
  }),
  g: defineMessage({
    id: "inpatient.prescribe.unit.g",
    defaultMessage: "g",
  }),
  tablet: defineMessage({
    id: "inpatient.prescribe.unit.tablet",
    defaultMessage: "{value, plural, one {tablet} other {tablets}}",
  }),
  ml: defineMessage({
    id: "inpatient.prescribe.unit.ml",
    defaultMessage: "ml",
  }),
  drop: defineMessage({
    id: "inpatient.prescribe.unit.drop",
    defaultMessage: "{value, plural, one {drop} other {drops}}",
  }),
  puff: defineMessage({
    id: "inpatient.prescribe.unit.puff",
    defaultMessage: "{value, plural, one {puff} other {puffs}}",
  }),
  unit: defineMessage({
    id: "inpatient.prescribe.unit.unit",
    defaultMessage: "{value, plural, one {unit} other {units}}",
  }),
  capsule: defineMessage({
    id: "inpatient.prescribe.unit.capsule",
    defaultMessage: "{value, plural, one {capsule} other {capsule}}",
  }),
  application: defineMessage({
    id: "inpatient.prescribe.unit.application",
    defaultMessage: "{value, plural, one {application} other {applications}}",
  }),
};
